import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Table1 from "./Table1";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-9 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                      Posting Date
                    </label>
                    <input
                      type="date"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                      Rounding Loss Allowance
                    </label>
                    <input
                      type="number"
                      className="form-control tableinput noborder"
                      style={{ fontSize: "0.8rem" }}
                      placeholder="0.5555"
                    />
                    <p className="py-1" style={{ fontSize: "0.5rem" }}>
                      Only values between (0,1) are allowed. Like (0.00, 0.04,
                      0.09) Ex: If allowance is set at 0.07,
                      <br />
                      accounts that have balance of 0.07 in either of the
                      currencies will be considered as zero <br />
                      balance account
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div
            className="col-md-12 px-2"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              className=""
              style={{
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: "1px solid #DBDBDB",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <p
                    className=""
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Exchange Rate Revaluation Account
                  </p>
                </div>
              </div>
              <Table1 setselected_item_data={setselected_item_data} />
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="col-md-9 px-2">
            <div
              style={{
                backgroundColor: "#E3F5DF",
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                gap: "15px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                    Gain/Loss from Revaluation
                  </label>
                  <input
                    type="number"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem" }}
                    placeholder="0.5555"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label htmlFor="" style={{ fontSize: "0.8rem" }}>
                    Total Gain/Loss
                  </label>
                  <input
                    type="number"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem" }}
                    placeholder="0.5555"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={CompanyList}
                    label="Gain/Loss already booked"
                    getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
                    value={pageState.Company}
                    onChange={(val) =>
                      handleChange("Gain/Lossalreadybooked", val)
                    }
                    placeholder=""
                  />
                  <p className="py-1" style={{ fontSize: "0.5rem" }}>
                    Gain/Loss accumulated in foreign currency account. Accounts
                    with '0' balance <br />
                    in either Base or Account currency
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
